import { useEffect, useState } from "react";
import api, { inr } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Link } from "react-router-dom";

export default function AccountPage() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  useEffect(() => { if (user) api.get("/orders/my").then((r) => setOrders(r.data)); }, [user]);
  if (!user) return <div className="max-w-3xl mx-auto py-32 px-6 text-center"><p>Please <Link to="/login" className="underline">sign in</Link>.</p></div>;

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-12 py-16">
      <p className="eyebrow">Your Account</p>
      <h1 className="font-serif text-4xl md:text-5xl mt-2">Hello, {user.name.split(" ")[0]}.</h1>

      <section className="mt-12">
        <h2 className="font-serif text-2xl mb-6">Orders</h2>
        {orders.length === 0 ? <p className="text-stone-500">No orders yet. <Link to="/shop/home" className="underline">Browse the collection</Link>.</p> : (
          <div className="divide-y divide-stone-200 border-t border-b border-stone-200">
            {orders.map((o) => (
              <div key={o.id} data-testid={`account-order-${o.id}`} className="py-4 flex justify-between items-center gap-4">
                <div>
                  <p className="text-sm">Order <span className="font-mono">{o.id.slice(0,8)}</span></p>
                  <p className="text-xs text-stone-500">{new Date(o.created_at).toLocaleDateString()} · {o.items.length} item(s)</p>
                </div>
                <div className="text-right">
                  <p>{inr(o.total)}</p>
                  <p className="text-xs uppercase tracking-widest text-[#8B5A2B]">{o.status}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
